import { Injectable, inject } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

const ERROR_TOAST_DURATION = 3000;

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly toastController = inject(ToastController);
  private readonly translate = inject(TranslateService);

  public async showErrorToast(translationKey: string): Promise<void> {
    const toast = await this.toastController.create({
      message: this.translate.instant(translationKey),
      duration: ERROR_TOAST_DURATION,
      color: 'danger',
      position: 'top',
    });

    await toast.present();
  }
}
